var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuitar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#ffffff",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {
      touchAction: "none"
    },
    transform: "translate(0,0)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.938 18.813l-17.72 2.375-89.374 11.968-6.22.844-1.562 6.094-18.5 72.156-136.187 137.28c-2.094-4.4-4.324-8.708-6.875-12.843-7.317-11.86-18.338-22.357-34.844-25.687-6.457-1.303-12.664-1.702-18.53-1.28-17.602 1.26-32.182 9.775-41.69 22.5-10.95 14.654-15.87 34.054-15.31 54.405-36.16 4.516-66.336 31.382-80.657 64.313-15.608 35.885-11.856 80.956 24.655 111.156 43.28 35.8 88.28 31.622 119.875 11.22 28.593-18.467 47.778-48.14 50.813-74.752 18.615-2.81 38.424-9.03 56.375-17.968 20.474-10.195 38.536-23.433 48.406-40.063l7.625-12.874-14.908-1.22c-34.56-2.818-53.76-12.87-66.406-26.217l146-147.22 18.938 1.375 6.156.438 2.813-5.5 6.125-11.907 25.03 11.906L464 132.438l-24.53-11.656 7.655-14.874 25.844 12.28 8.03-16.874-25.313-12.03L464 73.155 491.03 86l8.033-16.875L472.53 56.53l11.22-21.81 8.188-15.907zm-124.532 111l13.22 13.093-200.22 201.875c-1.556-1.983-3.227-3.898-5.062-5.717-2.65-2.628-5.493-4.96-8.47-7l200.532-202.25zm-235.47 210.093c10.914-.046 21.837 4.094 30.25 12.438 16.834 16.69 16.938 43.576.25 60.406-16.685 16.83-43.573 16.94-60.405.25-16.83-16.69-16.936-43.576-.25-60.406 8.345-8.415 19.245-12.64 30.157-12.688z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuitar);
export default __webpack_public_path__ + "static/media/guitar.fdce6b6c.svg";
export { ForwardRef as ReactComponent };